import * as types from 'inventory-listing/actions/listingUsedActionTypes.js';
import ListingUsedModel from 'inventory-listing/models/ListingUsedModel.js';

export default function listingUsedReducer(state = new ListingUsedModel(), action) {
    switch (action.type) {
        case types.SET_LISTING_USED:
            return action.listingUsed;

        case types.SELECT_PURCHASE_METHOD:
            return state.setIn(['paymentOptions', 'purchaseMethod'], action.purchaseMethod);

        case types.SELECT_MAXIMUM_TERM:
            return state.setIn(['paymentOptions', 'maximumTerm'], action.maximumTerm);

        case types.SELECT_PREFERRED_PAYMENT_FREQUENCY:
            return state.setIn(['paymentOptions', 'preferredPaymentFrequency'], action.paymentFrequency);

        case types.SET_INITIAL_CASH_DOWN:
            return state.setIn(['paymentOptions', 'initialCashDown'], action.cashDown);

        case types.SET_INITIAL_TARGET_PAYMENT:
            return state.setIn(['paymentOptions', 'initialTargetPayment'], action.targetPayment);

        case types.SET_PAYMENT_RANGE:
            return state.setIn(['paymentOptions', 'range'], action.paymentRange);

        case types.SET_VEHICLE_SORT:
            return state.set('vehicleOrders', action.sorting);

        case types.SET_VEHICLE_CRITERIA:
            return state.set('vehicleCriteria', action.vehicleCriteria);

        case types.SET_CONTEXT_URL:
            return state.set('contextUrl', action.contextUrl);

        case types.SET_VDP_URL:
            return state.set('vdpUrl', action.vdpUrl);

        case types.SET_DEALER_MAKE:
            return state.set('dealerMake', action.dealerMake);

        case types.SET_COLANDERS:
            return state.set('colanders', action.colanders);

        case types.SET_METADATAS:
            return state.set('metadatas', action.metadatas);

        case types.SET_PREFERRED_PURCHASE_METHOD:
            return state.setIn(['paymentOptions', 'preferredPurchaseMethod'], action.preferredPurchaseMethod);

        case types.REPLACE_URL:
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./client/src/reducers/listingUsedReducer.js